import {createFeature, createReducer, createSelector, on} from '@ngrx/store';
import {ChatActions} from "./chat.actions";

export interface AccountState {}

const initialState: any = {
    isOpen: false,
    unreadCount: 0
}

const reducer = createReducer(
  initialState,

  on(ChatActions.setIsOpen, (state, updatedState) => ({
    ...state,
    isOpen: updatedState.isOpen
  })),

  // on(ChatActions.setConversation, (state, updatedState) => ({
  //   ...state,
  //   conversation: updatedState.conversation
  // })),

  on(ChatActions.setUnreadCount, (state, updatedState) => ({
    ...state,
    unreadCount: updatedState.unreadCount
  })),

);

export const chatFeature = createFeature({
  name: 'Chat',
  reducer,
});

export const selectChat = (state: any) => state.Chat;

export const selectChatIsOpen = createSelector(
  selectChat,
  (state: any) => {
    return state.isOpen;
  }
);

// export const selectConversation = createSelector(
//   selectChat,
//   (state: any) => {
//     return state.conversation;
//   }
// );

